<div class="online-status">
	<ae-online-status-bubble [uids]="uids" />
</div>
